import { useContent } from "contexts/contentContext/contentContext";
import { FormDataT } from "./AdContactForm";
import styles from "./adContactForm.module.scss";
import Image from "components/Elements/Image/Image";
import { useState } from "react";

interface SubmittedFormI {
  formData: FormDataT;
}

const SubmittedForm = ({ formData }: SubmittedFormI) => {
  const { getTextByKey } = useContent();

  const [isMainImageLoaded, setIsMainImageLoaded] = useState(false);

  const handleMainImageLoad = () => {
    setIsMainImageLoaded(true);
  };

  return (
    <div className={styles.submittedFormContainer}>
      <div className={styles.animationHeaderContainer}>
        <Image
          name="dark-cloud"
          ext="png"
          className={styles.cloudIcon}
          onLoad={handleMainImageLoad}
        />
        <Image
          name="dark-cloud-shadow"
          ext="png"
          className={styles.cloudShadowIcon}
        />
        <Image
          name="blue-envelop"
          ext="png"
          className={`${styles.blueEnvelopIcon} ${
            isMainImageLoaded ? styles.animate : ""
          }`}
        />
        <Image
          name="mark-done"
          ext="png"
          className={`${styles.markDoneIcon} ${
            isMainImageLoaded ? styles.animate : ""
          }`}
        />
        <Image
          name="right-paper-airplane"
          ext="svg"
          className={`${styles.rightPaperAirplane} ${
            isMainImageLoaded ? styles.animate : ""
          }`}
        />
        <Image
          name="left-paper-airplane"
          ext="svg"
          className={`${styles.leftPaperAirplane} ${
            isMainImageLoaded ? styles.animate : ""
          }`}
        />
        <Image
          name="phone_icon_success"
          ext="svg"
          className={`${styles.phoneIcon} ${
            isMainImageLoaded ? styles.animate : ""
          }`}
        />
        <Image
          name="message-bubble"
          ext="svg"
          className={`${styles.messageBubble} ${
            isMainImageLoaded ? styles.animate : ""
          }`}
        />
      </div>

      <div className={styles.submittedFormHeader}>
        <h3 className={styles.submittedTitle}>
          {getTextByKey("contact-form-submitted-title")}
        </h3>
        <p className={styles.submittedDescription}>
          {getTextByKey("contact-form-submitted-description")}
        </p>
      </div>

      <div className={styles.submittedDataGrid}>
        <div className={styles.dataRow}>
          <div className={styles.dataField}>
            <label>{getTextByKey("contact-form-name-label")}</label>
            <p>{formData.name}</p>
          </div>
          <div className={styles.dataField}>
            <label>{getTextByKey("contact-form-email-label")}</label>
            <p>{formData.email}</p>
          </div>
        </div>

        <div className={styles.dataRow}>
          <div className={styles.dataField}>
            <label>{getTextByKey("contact-form-location-label")}</label>
            <p>{formData.location}</p>
          </div>
          <div className={styles.dataField}>
            <label>{getTextByKey("contact-form-company-label")}</label>
            <p>{formData.company}</p>
          </div>
        </div>

        <div className={styles.dataField}>
          <label>{getTextByKey("contact-form-budget-label")}</label>
          <p>{formData.budget} USD</p>
        </div>
      </div>
    </div>
  );
};

export default SubmittedForm;
